import { createContext, Dispatch, useContext } from 'react';
import { UserManagementReducerState, UserManagementSettingsAction } from '../reducer/types';

export interface UserManagementSettingsContextType {
    saveSettings: (saveAll?: boolean) => Promise<object>;
    reducerState: UserManagementReducerState;
    dispatch: Dispatch<UserManagementSettingsAction>;
    saveFunc: (newSettings: object, syncActiveDirectory?: boolean, includeFullError?: boolean) => Promise<object>;
}

export const UserManagementSettingsContext = createContext<UserManagementSettingsContextType | undefined>(undefined);

export const useUserManagementSettingsContext = (): UserManagementSettingsContextType => {
    const context = useContext(UserManagementSettingsContext);
    if (!context) {
        throw new Error('useUserManagementSettingsContext must be used within a UserManagementSettingsProvider');
    }
    return context;
};
